// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Intercom-style chat dock pinned bottom-right on console pages */

.chat-dock {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1000;
  /* No double-tap zoom on the chat surface; scrolls that hit an inner
     scroller's edge stay inside the dock instead of moving the page. */
  touch-action: manipulation;
  overscroll-behavior: contain;
  width: 380px;
  max-width: calc(100vw - 32px);
  height: 540px;
  /* Resizable up to the same 16px edge margin the dock keeps bottom/right */
  max-height: calc(100vh - 32px);
  /* Drag-resize measures the border box; keep CSS and JS sizes identical */
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: var(--chat-surface, #f1f4f8);
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: var(--radius);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

/* Maximized: a large centered window with a healthy margin, floating over
   a dimmed glass backdrop so it still reads as a window, not a page */
.chat-dock-maximized {
  bottom: 48px;
  right: 48px;
  width: calc(100vw - 96px);
  height: calc(100vh - 96px);
  max-height: calc(100vh - 96px);
}

/* Invisible drag handles for resizing the small window: the left edge
   adjusts width, the top edge height, the top-left corner both axes. The
   window is anchored bottom-right, so it grows up/left and shrinks back. A
   faint accent appears on hover so the affordance is discoverable. */
.chat-dock-resize-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  cursor: ew-resize;
  /* The handle owns the gesture on touch screens too */
  touch-action: none;
  z-index: 5;
}

.chat-dock-resize-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 6px;
  cursor: ns-resize;
  touch-action: none;
  z-index: 5;
}

.chat-dock-resize-corner {
  position: absolute;
  top: 0;
  left: 0;
  width: 16px;
  height: 16px;
  cursor: nwse-resize;
  touch-action: none;
  z-index: 6;
}

.chat-dock-resize-left:hover,
.chat-dock-resize-top:hover,
.chat-dock-resize-corner:hover {
  background: rgba(128, 128, 128, 0.25);
}

/* Dimmed, blurred page behind the maximized window; clicking it restores
   the window to its regular size */
.chat-dock-backdrop {
  position: fixed;
  inset: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.chat-dock-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--border-color, #d1d5db);
  background: var(--card-background, #f8f9fa);
  flex-shrink: 0;
}

.chat-dock-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--text-color);
  padding-left: 4px;
}

.chat-dock-team-picker {
  position: relative;
  min-width: 0;
}

.chat-dock-team-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 240px;
  padding: 3px 8px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-color);
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
}

.chat-dock-team-button:hover {
  background: rgba(128, 128, 128, 0.15);
}

.chat-dock-team-button svg {
  flex-shrink: 0;
}

.chat-dock-team-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-dock-team-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 10;
  min-width: 200px;
  max-height: 280px;
  overflow-y: auto;
  padding: 4px;
  border: 1px solid var(--border-color, #d1d5db);
  border-radius: var(--radius);
  background: var(--background-color, #fff);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.chat-dock-team-option {
  display: block;
  width: 100%;
  padding: 6px 10px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text-color);
  font-size: 0.875rem;
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-dock-team-option:hover {
  background: rgba(128, 128, 128, 0.12);
}

.chat-dock-team-option-active {
  color: var(--primary-color, #4a90d9);
  font-weight: 600;
}

.chat-dock-actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.chat-dock-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  /* Global button styles add padding that would squeeze the icon to
     zero width inside the fixed-size flex button */
  padding: 0;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--secondary-text-color, #6b7280);
  cursor: pointer;
}

.chat-dock-action svg {
  flex-shrink: 0;
}

.chat-dock-action:hover {
  background: rgba(128, 128, 128, 0.15);
  color: var(--text-color);
}

.chat-dock-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* The embedded AgentChat fills the dock body; its own header is redundant
   next to the dock header, keep it slim */
.chat-dock-body .agent-chat {
  flex: 1;
  min-height: 0;
  height: auto;
  border: none;
  border-radius: 0;
}

.chat-dock-launcher {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--button-primary-bg, #4a90d9);
  color: var(--button-primary-text, #fff);
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}

/* Unread chat-mention count on the launcher bubble */
.chat-dock-launcher-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 20px;
  height: 20px;
  padding: 0 5px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--danger-bg, #e5484d);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  border: 2px solid var(--surface-bg, #fff);
}

/* Mobile chat is an app surface, not a floating desktop window. Keep this
   contract after the base rules so the breakpoint owns every override. */
@media (max-width: 768px) {
  .chat-dock,
  .chat-dock.chat-dock-maximized {
    inset: 0;
    /* !important beats a drag-resized inline size stored on desktop */
    width: 100vw !important;
    width: 100dvw !important;
    height: 100vh !important;
    height: 100dvh !important;
    max-width: none;
    max-height: none;
    box-sizing: border-box;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }

  .chat-dock-backdrop,
  .chat-dock-maximize-action,
  .chat-dock-resize-left,
  .chat-dock-resize-top,
  .chat-dock-resize-corner {
    display: none;
  }

  .chat-dock-header {
    padding-top: calc(8px + env(safe-area-inset-top));
    padding-right: calc(10px + env(safe-area-inset-right));
    padding-left: calc(10px + env(safe-area-inset-left));
  }

  .chat-dock-body {
    overflow: hidden;
  }

  .chat-dock .chat-composer-container {
    padding-right: calc(12px + env(safe-area-inset-right));
    padding-bottom: calc(8px + env(safe-area-inset-bottom));
    padding-left: calc(12px + env(safe-area-inset-left));
  }

  .chat-dock .chat-composer-input {
    min-height: 65px;
  }

  .chat-dock-launcher {
    right: calc(16px + env(safe-area-inset-right));
    bottom: calc(16px + env(safe-area-inset-bottom));
  }
}
`, "",{"version":3,"sources":["webpack://./src/chat-dock.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb;uEACqE;EACrE,0BAA0B;EAC1B,4BAA4B;EAC5B,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,0EAA0E;EAC1E,8BAA8B;EAC9B,yEAAyE;EACzE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,8CAA8C;EAC9C,4BAA4B;EAC5B,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;sEACsE;AACtE;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;;qEAGqE;AACrE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;mCACmC;AACnC;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,qDAAqD;EACrD,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,8CAA8C;EAC9C,4BAA4B;EAC5B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ;mDACiD;EACjD,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;0CAC0C;AAC1C;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,uCAAuC;EACvC,eAAe;EACf,0CAA0C;AAC5C;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;yEACyE;AACzE;EACE;;IAEE,QAAQ;IACR,kEAAkE;IAClE,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;;;;IAKE,aAAa;EACf;;EAEA;IACE,iDAAiD;IACjD,sDAAsD;IACtD,oDAAoD;EACtD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sDAAsD;IACtD,uDAAuD;IACvD,oDAAoD;EACtD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8CAA8C;IAC9C,gDAAgD;EAClD;AACF","sourcesContent":["/* Intercom-style chat dock pinned bottom-right on console pages */\n\n.chat-dock {\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  z-index: 1000;\n  /* No double-tap zoom on the chat surface; scrolls that hit an inner\n     scroller's edge stay inside the dock instead of moving the page. */\n  touch-action: manipulation;\n  overscroll-behavior: contain;\n  width: 380px;\n  max-width: calc(100vw - 32px);\n  height: 540px;\n  /* Resizable up to the same 16px edge margin the dock keeps bottom/right */\n  max-height: calc(100vh - 32px);\n  /* Drag-resize measures the border box; keep CSS and JS sizes identical */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  background: var(--chat-surface, #f1f4f8);\n  border: 1px solid var(--border-color, #d1d5db);\n  border-radius: var(--radius);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n/* Maximized: a large centered window with a healthy margin, floating over\n   a dimmed glass backdrop so it still reads as a window, not a page */\n.chat-dock-maximized {\n  bottom: 48px;\n  right: 48px;\n  width: calc(100vw - 96px);\n  height: calc(100vh - 96px);\n  max-height: calc(100vh - 96px);\n}\n\n/* Invisible drag handles for resizing the small window: the left edge\n   adjusts width, the top edge height, the top-left corner both axes. The\n   window is anchored bottom-right, so it grows up/left and shrinks back. A\n   faint accent appears on hover so the affordance is discoverable. */\n.chat-dock-resize-left {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 6px;\n  height: 100%;\n  cursor: ew-resize;\n  /* The handle owns the gesture on touch screens too */\n  touch-action: none;\n  z-index: 5;\n}\n\n.chat-dock-resize-top {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 6px;\n  cursor: ns-resize;\n  touch-action: none;\n  z-index: 5;\n}\n\n.chat-dock-resize-corner {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 16px;\n  height: 16px;\n  cursor: nwse-resize;\n  touch-action: none;\n  z-index: 6;\n}\n\n.chat-dock-resize-left:hover,\n.chat-dock-resize-top:hover,\n.chat-dock-resize-corner:hover {\n  background: rgba(128, 128, 128, 0.25);\n}\n\n/* Dimmed, blurred page behind the maximized window; clicking it restores\n   the window to its regular size */\n.chat-dock-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 999;\n  background: rgba(0, 0, 0, 0.35);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.chat-dock-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--border-color, #d1d5db);\n  background: var(--card-background, #f8f9fa);\n  flex-shrink: 0;\n}\n\n.chat-dock-title {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: var(--text-color);\n  padding-left: 4px;\n}\n\n.chat-dock-team-picker {\n  position: relative;\n  min-width: 0;\n}\n\n.chat-dock-team-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 240px;\n  padding: 3px 8px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-color);\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n}\n\n.chat-dock-team-button:hover {\n  background: rgba(128, 128, 128, 0.15);\n}\n\n.chat-dock-team-button svg {\n  flex-shrink: 0;\n}\n\n.chat-dock-team-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-dock-team-options {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 10;\n  min-width: 200px;\n  max-height: 280px;\n  overflow-y: auto;\n  padding: 4px;\n  border: 1px solid var(--border-color, #d1d5db);\n  border-radius: var(--radius);\n  background: var(--background-color, #fff);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n}\n\n.chat-dock-team-option {\n  display: block;\n  width: 100%;\n  padding: 6px 10px;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text-color);\n  font-size: 0.875rem;\n  text-align: left;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-dock-team-option:hover {\n  background: rgba(128, 128, 128, 0.12);\n}\n\n.chat-dock-team-option-active {\n  color: var(--primary-color, #4a90d9);\n  font-weight: 600;\n}\n\n.chat-dock-actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.chat-dock-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  /* Global button styles add padding that would squeeze the icon to\n     zero width inside the fixed-size flex button */\n  padding: 0;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--secondary-text-color, #6b7280);\n  cursor: pointer;\n}\n\n.chat-dock-action svg {\n  flex-shrink: 0;\n}\n\n.chat-dock-action:hover {\n  background: rgba(128, 128, 128, 0.15);\n  color: var(--text-color);\n}\n\n.chat-dock-body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n/* The embedded AgentChat fills the dock body; its own header is redundant\n   next to the dock header, keep it slim */\n.chat-dock-body .agent-chat {\n  flex: 1;\n  min-height: 0;\n  height: auto;\n  border: none;\n  border-radius: 0;\n}\n\n.chat-dock-launcher {\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  padding: 0;\n  border: none;\n  border-radius: 50%;\n  background: var(--button-primary-bg, #4a90d9);\n  color: var(--button-primary-text, #fff);\n  cursor: pointer;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);\n}\n\n/* Unread chat-mention count on the launcher bubble */\n.chat-dock-launcher-badge {\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 5px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--danger-bg, #e5484d);\n  color: #fff;\n  font-size: 0.72rem;\n  font-weight: 700;\n  line-height: 1;\n  border: 2px solid var(--surface-bg, #fff);\n}\n\n/* Mobile chat is an app surface, not a floating desktop window. Keep this\n   contract after the base rules so the breakpoint owns every override. */\n@media (max-width: 768px) {\n  .chat-dock,\n  .chat-dock.chat-dock-maximized {\n    inset: 0;\n    /* !important beats a drag-resized inline size stored on desktop */\n    width: 100vw !important;\n    width: 100dvw !important;\n    height: 100vh !important;\n    height: 100dvh !important;\n    max-width: none;\n    max-height: none;\n    box-sizing: border-box;\n    border: 0;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .chat-dock-backdrop,\n  .chat-dock-maximize-action,\n  .chat-dock-resize-left,\n  .chat-dock-resize-top,\n  .chat-dock-resize-corner {\n    display: none;\n  }\n\n  .chat-dock-header {\n    padding-top: calc(8px + env(safe-area-inset-top));\n    padding-right: calc(10px + env(safe-area-inset-right));\n    padding-left: calc(10px + env(safe-area-inset-left));\n  }\n\n  .chat-dock-body {\n    overflow: hidden;\n  }\n\n  .chat-dock .chat-composer-container {\n    padding-right: calc(12px + env(safe-area-inset-right));\n    padding-bottom: calc(8px + env(safe-area-inset-bottom));\n    padding-left: calc(12px + env(safe-area-inset-left));\n  }\n\n  .chat-dock .chat-composer-input {\n    min-height: 65px;\n  }\n\n  .chat-dock-launcher {\n    right: calc(16px + env(safe-area-inset-right));\n    bottom: calc(16px + env(safe-area-inset-bottom));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
